// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"69a5e8d8","337":"3c5b1266","667":"f7cdeabf"}[chunkId] + ".chunk.js";
};